import { fetchClient } from '@/api/client';
import { body } from '@/api/call';
import type { DownloadAdapter } from '@/components/downloads';
import { modelExportSnapshot } from './modelExportProgress';
export const modelExportDownloadAdapter:DownloadAdapter={
  async observe(pin,signal){
    if(pin.kind!=='model_export')throw new Error('Invalid model export operation');
    const {job}=await body(fetchClient.GET('/api/jobs/{job_id}',{params:{path:{job_id:pin.jobId}},signal}));
    return modelExportSnapshot(pin,job);
  },
  async retry(){throw new Error('Retry from the export job to preserve its actual server permissions.');},
  async access(){throw new Error('Open model files to download the completed export.');},
};
